import Legal from "../../views/modules/legal/Legal";
import LegalTaps from "../../views/modules/legal/legaltaps";
//import DocumentList from "../../views/modules/legal/documents/DocumentList";
// import KPI from "../../views/modules/legal/KPI";

import layouts from "../../layout";

export default {
  path: "/legal",
  name: "legal",
  component: Legal,
  meta: {
    auth: true
  },
  redirect: {
    name: "legal-document"
  },
  children: [
    {
      path: "documents",
      name: "legal-document",
      component: LegalTaps,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["legal", "documents"],
        index: true
      }
    }
    // {
    //   path: "kpi",
    //   name: "legal-kpi",
    //   component: KPI,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "KPI",
    //     tags: ["legal", "kpi"],
    //     index: true
    //   }
    // }
  ]
};
